import { Engine } from "./../models/engine";
import { Powertrain } from "./../models/powertrain";
import { ConfirmCancelChangesDialogComponent } from "./../dialog/confirm-cancel-changes-dialog/confirm-cancel-changes-dialog.component";
import { SideMenuServiceService } from "./../services/side-menu-service.service";
import { SettingService } from "./../services/setting.service";
import { Helper } from "./../common/helper";
import { AuthService } from "./../services/auth.service";
import { Enums } from "./../common/enums";
import { ActionService } from "./../services/action.service";
import { Visit } from "./../models/visit";
import { MessageService } from "../services/message.service";
import { Message } from "../common/message";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { VisitService } from "../services/visit.service";
import { PowertrainService } from "../services/powertrain.service";
import { WorkshopService } from "../services/workshop.service";
import { TroubleshootingService } from "../services/troubleshooting.service";
import { CatalogService } from "../services/catalog.service";
import { forkJoin } from "rxjs";
import { OrderPrintService } from "../service/order-print.service";
import { Router } from "@angular/router";

let ELEMENT_DATA = [];

@Component({
  selector: "app-visit-report",
  templateUrl: "./visit-report.component.html",
  styleUrls: ["./visit-report.component.scss"],
})
export class VisitReportComponent implements OnInit {
  @Input() requestType: string;
  @Input() title: string = "Life Record Report";
  @Input() isOrderDone: boolean = false;
  @Input() hideActionsColumn: boolean = true;
  @Input() isReminder: boolean = false;
  @Input() isTroubleShhotingLifeRecord: boolean = false;

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  troubleShootingColumns: string[] = [
    "SN",
    "troubleshootingCode",
    "troubleshootingName",
    "date",
    "time",
    "powertrain",
    "engine",
    "workshop",
    "hoursread",
  ];
  visitColumns: string[] = [
    "SN",
    "date",
    "visitDate",
    "time",
    "powertrain",
    "engine",
    "workshop",
    "hoursread",
    "reviewed",
    "updatedBy",
    "created",
  ];
  orderColumns: string[] = [
    "SN",
    "orderGeneratedDate",
    "date",
    "orderNumber",
    "orderHour",
    "powertrain",
    "engine",
    "workshop",
    "hoursread",
    "updatedBy",
    "created",
  ];
  displayedColumns: string[];
  dataSource = new MatTableDataSource();
  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  engines: any;
  actions: any;
  catalog: any;
  troubleshooting: any;
  settings: any;
  workShops: any;
  actionType = Enums.actionType;
  troubleShootingType = Enums.troubhleShootingType;
  resource: Visit = new Visit();
  nextMaintenance: number;
  lastOrderHour: number;
  lastVisitHour: number;
  lastVisitDate: Date;
  today: Date = new Date();
  isOrderComponent: boolean = false;
  lastEngineOrder: any;
  visitOrder: any;
  lastEngineVisit: any;
  prevLastEngineVisit: any;
  searchObject: any = {
    powerCoach: null,
    engine: null,
    dateFrom: null,
    dataTo: null,
  };
  searchedEngines: any;
  searchedList: any;
  printedPowerCoach: string = "كل العربات";
  printedEngine: string = "كل المحركات";
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private ptService: PowertrainService,
    private service: VisitService,
    private formBuilder: FormBuilder,
    private msg: MessageService,
    private wsService: WorkshopService,
    private actionService: ActionService,
    private authService: AuthService,
    private settingService: SettingService,
    private catalogService: CatalogService,
    private orderPrintService: OrderPrintService,
    private router: Router,
    private sideMenuService: SideMenuServiceService,
    private tsService: TroubleshootingService
  ) {}

  ngOnInit() {
    this.setMessageForm();
    this.initData();
    this.getTableColumns();
  }
  //serach
  searchByPowerCoach(powerCoach) {
    this.searchedList = [];
    if (powerCoach && powerCoach != "null") {
      for (let obj of this.powerTrains) {
        if (obj.id == powerCoach) {
          this.printedPowerCoach = obj.name + " - " + obj.code;
          //this.updateDataSource(this.searchedList);
          if (obj && obj.motors && obj.motors.length) {
            this.searchedEngines = obj.motors;
            this.searchObject.engine = null;
            return;
          } else {
            this.searchedEngines = [];
            this.searchObject.engine = null;
            return;
          }
        }
      }
    } else {
      this.printedPowerCoach = "كل العربات";
      this.searchObject.engine = null;
      this.searchedEngines = [];
      this.searchedList = ELEMENT_DATA;
      this.updateDataSource();
    }
  }

  isBtnSearchDisabled() {
    if (this.searchObject.powerCoach != null) return false;
    else return true;
  }

  searchVisits() {
    this.getResources().subscribe((result: any) => {
      //fetch visits
      if (result && result.length) {
        ELEMENT_DATA = [];
        if (this.isTroubleShhotingLifeRecord) {
          let listOfTroubleSgooting = this.prepareTrounbleShootingList(result);
          ELEMENT_DATA = ELEMENT_DATA.concat(listOfTroubleSgooting);
        } else {
          ELEMENT_DATA = ELEMENT_DATA.concat(result);
        }

        this.updateDataSource();
      } else {
        ELEMENT_DATA = [];
        this.updateDataSource();
      }
    });
  }

  prepareTrounbleShootingList(result: any) {
    let list = [];
    for (let item of result) {
      for (let trouble of item.troubleshooting) {
        if (trouble.status) {
          item.troubleshootingCode = trouble.code;
          item.troubleshootingName = trouble.name;
          console.log("newItem : ", item);
          list.push(item);
        }
      }
    }
    return list;
  }

  searchByEngine(engine) {
    //let arr = [];
    if (engine && engine != "null") {
      for (let row of this.searchedEngines) {
        if (row.id == engine) {
          this.printedEngine = row.name + " - " + row.code;
        }
      }
    } else {
      this.printedEngine = "كل المحركات";
    }
  }
  ///////////////////////////init data
  getTableColumns() {
    if (this.isOrder()) {
      this.isOrderComponent = true;
      this.displayedColumns = this.orderColumns;
    }

    if (this.isVisit()) {
      this.displayedColumns = this.visitColumns;
    }

    if (!this.hideActionsColumn && this.displayedColumns) {
      this.displayedColumns.push("actions");
    }

    if (this.isTroubleShhotingLifeRecord) {
      this.displayedColumns = this.troubleShootingColumns;
    }
  }

  initData() {
    forkJoin([
      this.getCatalog(),
      this.getSettings(),
      this.getActions(),
      this.getPowertrains(),
      this.getTroubleShooting(),
      this.getWorkShops(),
      //this.getResources(),
    ]).subscribe(
      (results: any) => {
        if (!results) return;

        if (results[0] && results[0].length) {
          this.catalog = results[0];
          //this.setActionStatus(this.catalog, true);
        }

        if (results[1] && results[1].length) {
          this.settings = results[1][0];
        }

        if (results[2] && results[2].length) {
          this.actions = this.actions.concat(results[2]);
          this.setActionStatus(this.actions, false);
        }

        if (results[3] && results[3].length) {
          this.powerTrains = this.powerTrains.concat(results[3]);
        }

        if (results[4] && results[4].length) {
          this.troubleshooting = this.troubleshooting.concat(results[4]);
          this.setActionStatus(this.troubleshooting, false);
        }

        if (results[5] && results[5].length) {
          this.workShops = this.workShops.concat(results[5]);
        }

        // if (results[6] && results[6].length) {
        //   ELEMENT_DATA = [];
        //   if (results[6] && results[6].length) {
        //     ELEMENT_DATA = ELEMENT_DATA.concat(results[6]);
        //   }
        //   this.updateDataSource();
        // } else {
        //   ELEMENT_DATA = [];
        //   this.updateDataSource();
        // }
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_LOAD_INIT_DATA);
      }
    );
  }

  setActionStatus(actions: any, status: boolean) {
    for (let action of actions) {
      action.status = status;
    }
  }

  getCatalog() {
    return this.catalogService.getAll();
  }

  getSettings() {
    return this.settingService.getAll();
  }

  getWorkShops() {
    this.workShops = [];
    return this.wsService.getAll();
  }

  getActions() {
    this.actions = [];
    return this.actionService.getAll();
  }

  getTroubleShooting() {
    this.troubleshooting = [];
    return this.tsService.getAll();
  }

  getPowertrains() {
    this.powerTrains = [];
    this.engines = [];
    return this.ptService.getAll();
  }

  getResources() {
    ELEMENT_DATA = [];
    return this.service.getAllResources(
      this.requestType,
      this.isOrderDone,
      this.isReminder,
      this.searchObject.powerCoach,
      this.searchObject.engine,
      null,
      null,
      0,
      300,
      this.searchObject.dateFrom,
      this.searchObject.dateTo
    );
  }

  clearDates() {
    this.searchObject.dateFrom = null;
    this.searchObject.dateTo = null;
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      date: ["", Validators.required],
      time: ["", Validators.required],
      hoursread: ["", Validators.required],
      requestType: ["", Validators.required],
      orderNumber: ["", Validators.required],
      orderHour: ["", Validators.required],
      actions: ["", Validators.required],
      notes: ["", Validators.required],
      start: ["", Validators.required],
      end: ["", Validators.required],
      supervisor: ["", Validators.required],
      generatorNumber: ["", Validators.required],
      reviewed: ["", Validators.required],
      accountId: ["", Validators.required],
      reviewerId: ["", Validators.required],
      powertrainId: [
        { value: "", disabled: this.isOrder() },
        Validators.required,
      ],
      motorId: [{ value: "", disabled: this.isOrder() }, Validators.required],
      workshopId: [
        { value: "", disabled: this.isOrder() },
        Validators.required,
      ],
      actionStatus: ["", Validators.required],
      lastvisithour: ["", Validators.required],
      lastorderhour: ["", Validators.required],
    });
  }

  ///////////////////////////////////

  updateDataSource(list?: any) {
    if (list) {
      this.dataSource = new MatTableDataSource<any>(list);
      this.dataSource.paginator = this.paginator;
      return;
    }

    if (ELEMENT_DATA && ELEMENT_DATA.length) {
      this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    } else {
      this.dataSource = new MatTableDataSource<any>([]);
    }
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resetForm();
    this.isFormDisplay = true;
    this.resource.actions = this.actions;
    this.resource.troubleshooting = this.troubleshooting;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  goBack() {
    this.isFormDisplay = false;
  }

  selectAll(arr: any) {
    for (let obj of arr) {
      obj.status = true;
    }
  }

  isLastEngineVisit() {
    if (this.lastEngineVisit && this.lastEngineVisit.id == this.resource.id)
      return true;
    else return false;
  }

  isFormDisabled() {
    let isVisitUsedByDataEntry =
      this.resource.id && this.authService.isDataEntry() && this.isVisit();
    let isOrderAndDone = this.resource.orderDone;
    let isVisitReviewed = this.isVisit() && this.resource.reviewed;
    let orderAuditDisabled = this.isOrder() && this.authService.isAudit();
    //|| (this.resource.id && !this.isLastEngineVisit() && this.isVisit())
    if (
      isVisitUsedByDataEntry ||
      orderAuditDisabled ||
      isOrderAndDone ||
      isVisitReviewed
    )
      return true;
    else return false;
  }

  onSave() {
    this.submitted = true;

    if (!this.resource) return;
    if (!this.resource.date) return;
    if (!this.resource.time) return;
    if (!this.resource.hoursread) return;
    if (!this.resource.powertrainId) return;
    if (!this.resource.motorId) return;
    if (!this.resource.start) return;
    if (!this.resource.end) return;
    if (!this.resource.supervisor) return;
    if (!this.resource.workshopId) return;

    if (this.authService.isAudit()) {
      this.resource.reviewed = true;
      this.resource.reviewerId = this.authService.getUserData().id;
    }
    if (this.resource.id) {
      this.updateElement();
    } else {
      this.addElement();
    }
  }

  checkEngineHoursRead(hoursread: number) {
    if (!this.resource.motorId || !this.lastVisitHour) {
      this.msg.alert(Message.CHOOSE_ENGINE_FIRST);
      return false;
    }

    if (hoursread <= this.lastVisitHour) {
      this.msg.alert(Message.ENGINE_HOURS_MUST_BE_GREATER_THAN_PREV_READ);
      this.resource.hoursread = null;
      return false;
    }

    if (
      this.prevLastEngineVisit &&
      hoursread < this.prevLastEngineVisit.hoursread
    ) {
      this.msg.alert(Message.ENGINE_HOURS_MUST_BE_GREATER_THAN_PREV_READ);
      this.resource.hoursread = null;
      return false;
    }

    if (hoursread + this.settings.workhoursexceed >= this.nextMaintenance) {
      return true;
    }

    return false;
  }

  onPowerTrainChange(pt) {
    this.lastOrderHour = 0;
    this.lastVisitHour = 0;
    this.lastVisitDate = null;
    for (var obj of this.powerTrains) {
      if (obj.id == pt) {
        if (obj && obj.motors && obj.motors.length) {
          this.engines = obj.motors;
          this.resource.motorId = null;
          this.resource.generatorNumber = null;
          return;
        } else {
          this.engines = [];
          this.resource.motorId = null;
          this.resource.generatorNumber = null;
          return;
        }
      }
    }
    this.engines = [];
    this.resource.motorId = null;
    this.resource.generatorNumber = null;
  }

  onEngineChange(engine: string) {
    for (let pt of this.powerTrains) {
      for (let e of pt.motors) {
        if (e.id == engine) {
          if (e && e.code) {
            this.resource.generatorNumber = e.code;
          }
        }
      }
    }
    if (!this.resource.generatorNumber) this.resource.generatorNumber = null;

    forkJoin([
      this.service.getEngineLastOrderHour(engine),
      this.service.getEngineLastVisitHour(engine),
      this.service.getEngineLastOrderDetails(engine),
      this.service.getVisitOrder(this.resource.id),
    ]).subscribe(
      (results: any) => {
        this.lastOrderHour =
          results && results[0] && results[0][0] && results[0][0].orderHour
            ? results[0][0].orderHour
            : 0;
        this.lastVisitDate =
          results && results[1] && results[1][0]
            ? results[1][0].visitDate || results[1][0].date
            : null;
        this.lastEngineOrder =
          results && results[2] && results[2][0] ? results[2][0] : null;
        this.lastEngineVisit =
          results && results[1] && results[1][0] ? results[1][0] : null;
        this.prevLastEngineVisit =
          results && results[1] && results[1][1] ? results[1][1] : null;
        this.visitOrder =
          results && results[3] && results[3][0] ? results[3][0] : null;

        if (this.resource.id && this.isVisit() && !this.isFormDisabled()) {
          this.lastVisitHour =
            this.prevLastEngineVisit && this.prevLastEngineVisit.hoursread
              ? this.prevLastEngineVisit.hoursread
              : Helper.getObjectFromAnArrayByObjectId(this.engines, engine)
                  .hoursread;
        } else {
          this.lastVisitHour =
            this.lastEngineVisit && this.lastEngineVisit.hoursread
              ? this.lastEngineVisit.hoursread
              : Helper.getObjectFromAnArrayByObjectId(this.engines, engine)
                  .hoursread;
        }

        if (this.isOrder()) this.nextMaintenance = this.lastOrderHour + 200 * 2;
        else this.nextMaintenance = this.lastOrderHour + 200;

        if (this.lastVisitHour - this.lastOrderHour > this.nextMaintenance) {
          this.msg.alert(Message.MAINTENANCE_SKIPPED + this.nextMaintenance);
        }
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_IN_GET_LAST_ENGINE_HOURS);
      }
    );
  }

  checkHoursRead(hoursread: number) {
    if (hoursread) {
      if (this.checkEngineHoursRead(hoursread))
        this.msg.alert(Message.ORDER_WILL_GENERATED);
    }
  }

  resetForm(ret?: boolean) {
    this.setActionStatus(this.actions, false);
    this.setActionStatus(this.troubleshooting, false);
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  isVisit() {
    if (this.requestType == "visit") return true;
    else return false;
  }

  isOrder() {
    if (this.requestType == "order") return true;
    else return false;
  }

  addElement() {
    if (this.checkEngineHoursRead(this.resource.hoursread)) {
      this.resource.isOrderGeneratedFromVisit = true;
    } else {
      this.resource.isOrderGeneratedFromVisit = false;
    }

    this.resource.requestType = this.requestType;
    this.resource.accountId = this.authService.getUserData().id;
    this.service.create(this.resource).subscribe((result: any) => {
      if (result && result.isOrderGeneratedFromVisit) {
        this.addOrder(result);
      }
      this.msg.alert(Message.SAVE);
      result.powertrain = Helper.getObjectFromAnArrayByObjectId(
        this.powerTrains,
        result.powertrainId
      );
      result.motor = Helper.getObjectFromAnArrayByObjectId(
        this.engines,
        result.motorId
      );
      result.workshop = Helper.getObjectFromAnArrayByObjectId(
        this.workShops,
        result.workshopId
      );
      result.addedBy = this.authService.getUserData();
      ELEMENT_DATA.unshift(result);
      this.updateDataSource();
      this.resetForm(true);
    });
  }

  updateElement() {
    // check-do-all-maintenance-tasks
    if (
      this.authService.isDataEntry() &&
      this.resource.catalog &&
      this.resource.catalog.length
    ) {
      let catalogList = this.resource.catalog;
      for (let cat of catalogList) {
        if (!cat.status) {
          this.msg.alert(Message.DO_ALL_TASKS);
          return;
        }
      }
    }
    /////////////////////////////////////////////////
    if (this.checkEngineHoursRead(this.resource.hoursread)) {
      this.resource.isOrderGeneratedFromVisit = true;
    } else {
      this.resource.isOrderGeneratedFromVisit = false;
    }

    if (this.isOrder()) {
      this.resource.orderDone = true;
      this.resource.reminder = 0;
      this.resource.orderDoneBy = this.authService.getUserData().id;
    }

    this.resource.accountId = this.authService.getUserData().id;

    this.service.update(this.resource).subscribe((result: any) => {
      result.powertrain = Helper.getObjectFromAnArrayByObjectId(
        this.powerTrains,
        result.powertrainId
      );
      result.motor = Helper.getObjectFromAnArrayByObjectId(
        this.engines,
        result.motorId
      );
      result.workshop = Helper.getObjectFromAnArrayByObjectId(
        this.workShops,
        result.workshopId
      );
      result.addedBy = this.authService.getUserData();
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id === this.resource.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });
      this.updateDataSource();
      this.resetForm(true);

      //when execut order
      if (result.requestType == "order") {
        this.msg.alert(Message.ORDER_EXECURED);
        if (result.isOrderGeneratedFromVisit) this.addOrder(result);
        else {
          this.sideMenuService.getUnDoneOrdersCount();
          this.sideMenuService.getReminderedOrdersCount();
          this.initData();
        }
      } else {
        this.msg.alert(Message.UPDATE);
        //check if the visit has an order generated before or not
        // if no generate a new one
        // if yes update the related order
        if (this.visitOrder) {
          this.updateOrder(result);
        } else {
          if (result.isOrderGeneratedFromVisit) this.addOrder(result);
          else {
            //delete related order if exist
            this.service.getByVisitId(result.id).subscribe((results: any) => {
              if (!(results && results.length)) return;
              let result = results[0];
              this.deleteOrderDEtailsByOrderId(result.id);
            });
          }
        }
      }
    });
  }

  editElement(ele: Visit) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource.accountId = ele.accountId;
    this.resource.actions = ele.actions;
    this.resource.date = ele.date
      ? ele.date.toString().substring(0, ele.date.toString().length - 14)
      : null;

    this.resource.visitDate = ele.visitDate
      ? (ele.visitDate || ele.date)
          .toString()
          .substring(0, ele.visitDate.toString().length - 14)
      : null;
    this.resource.end = ele.end;
    this.resource.generatorNumber = ele.generatorNumber;
    this.resource.id = ele.id;
    this.resource.notes = ele.notes;
    this.resource.orderDone = ele.orderDone;
    this.resource.orderHour = ele.orderHour;
    this.resource.orderNumber = ele.orderNumber;
    this.resource.powertrainId = ele.powertrainId;
    this.onPowerTrainChange(this.resource.powertrainId);
    this.resource.motorId = ele.motorId;
    this.onEngineChange(ele.motorId);
    this.resource.requestType = ele.requestType;
    this.resource.reviewed = ele.reviewed;
    this.resource.reviewerId = ele.reviewerId;
    this.resource.start = ele.start;
    this.resource.supervisor = ele.supervisor;
    this.resource.time = ele.time;
    this.resource.troubleshooting = ele.troubleshooting;
    this.resource.workshopId = ele.workshopId;
    this.resource.hoursread = ele.hoursread;
    this.resource.visitId = ele.visitId;
    this.resource.orderGeneratedDate = ele.orderGeneratedDate;
    if (this.isOrder()) {
      this.resource.catalog = ele.catalog;
      if (!ele.orderDone) {
        this.resource.hoursread = null;
        this.setActionStatus(this.resource.troubleshooting, false);
        this.setActionStatus(this.resource.actions, false);
      }
    }
  }

  prepareOrder(visit: any) {
    let order = Object.assign({}, visit);
    order.requestType = "order";
    order.visitId = visit.id;
    order.actions = this.actions;
    order.orderHour = this.nextMaintenance;
    order.troubleshooting = this.troubleshooting;
    order.start = null;
    order.end = null;
    order.supervisor = null;
    order.notes = null;
    order.time = null;
    order.date = null;
    order.visitDate = null;
    order.id = null;
    order.hoursread = null;
    order.orderDone = false;
    // زي visit.component: Object.assign بينسخ رقم المصدر، فبنصفّره هنا عشان
    // الأمر الجديد ما يورّثش رقم أمر تاني. مسار التحديث بيرجّع الرقم بنفسه.
    order.orderNumber = null;
    order.orderGeneratedDate = null;
    order.accountId = this.authService.getUserData().id;
    //get catalog items to set to order per next mainrenance hour

    order.catalog = this.getOrderCatalogPerNextMaintenanceHour(order.orderHour);

    return order;
  }

  getOrderCatalogPerNextMaintenanceHour(hour: number) {
    let orderCatalog = this.catalog;

    if (Math.round(hour % 600) > 0) {
      orderCatalog = this.removeFromCatalogBySn(15, orderCatalog);
    }

    if (Math.round(hour % 2000) > 0) {
      orderCatalog = this.removeFromCatalogBySn(17, orderCatalog);
    }

    if (Math.round(hour % 6000) > 0) {
      orderCatalog = this.removeFromCatalogBySn(18, orderCatalog);
    }

    if (Math.round(hour % 10000) > 0) {
      orderCatalog = this.removeFromCatalogBySn(19, orderCatalog);
    }

    return orderCatalog;
  }

  removeFromCatalogBySn(sn: any, orderCatalog: any) {
    let arr = [];
    for (let c of orderCatalog) {
      if (c.code != sn) {
        arr.push(c);
      }
    }

    return arr;
  }

  updateOrderRemider(result: any) {
    result.reminder = result.reminder ? result.reminder + 1 : 1;
    this.service.update(result).subscribe((result) => {
      //
      this.msg.alert(Message.ORDER_GENERATED_REMINDERED_SUCCESSFULLY);
      this.sideMenuService.getReminderedOrdersCount();
      //this.initData();
    });
  }

  addNewOrder(order) {
    this.service.create(order).subscribe((result: any) => {
      //call service update order count
      this.msg.alert(Message.ORDER_GENERATED_SUCCESSFULLY);
      this.sideMenuService.getUnDoneOrdersCount();
      //this.initData();
    });
  }

  addOrder(visit: any) {
    let order = this.prepareOrder(visit);
    //check if engine has pending order
    this.service
      .getEngineLastOrderDetails(visit.motorId)
      .subscribe((results: any) => {
        if (!(results && results.length)) {
          this.addNewOrder(order);
          return;
        }

        let result = results[0];
        if (
          result &&
          !result.orderDone &&
          result.orderHour == order.orderHour
        ) {
          // add reminder to the order
          this.updateOrderRemider(result);
        } else {
          //add new order
          this.addNewOrder(order);
        }
      });
  }

  updateOrderDetails(order: any) {
    order.isReviewd = true;
    this.service.update(order).subscribe((result) => {
      this.msg.alert(Message.ORDER_GENERATED_UPDATED_SUCCESSFULLY);
      this.sideMenuService.getUnDoneOrdersCount();
      this.sideMenuService.getReminderedOrdersCount();
      if (this.isOrder()) this.initData();
    });
  }

  updateOrder(visit: any) {
    if (visit.isOrderGeneratedFromVisit) {
      //update order details
      let order = this.prepareOrder(visit);
      if (this.visitOrder) {
        order.id = this.visitOrder.id;
        order.orderNumber = this.visitOrder.orderNumber;
        order.orderGeneratedDate = this.visitOrder.orderGeneratedDate;
        this.updateOrderDetails(order);
      } else {
        this.service.getByVisitId(visit.id).subscribe((results: any) => {
          if (!(results && results.length)) return;
          let result = results[0];
          order.id = result.id;
          order.orderNumber = result.orderNumber;
          order.orderGeneratedDate = result.orderGeneratedDate;
          this.updateOrderDetails(order);
        });
      }
    } else {
      //delete order details
      if (this.visitOrder) {
        this.deleteOrderDEtailsByOrderId(this.visitOrder.id);
      } else {
        this.service.getByVisitId(visit.id).subscribe((results: any) => {
          if (!(results && results.length)) return;
          let result = results[0];
          this.deleteOrderDEtailsByOrderId(result.id);
        });
      }
    }
  }

  deleteOrderDEtailsByOrderId(orderId: string) {
    this.service.delete(orderId).subscribe((result) => {
      this.msg.alert(Message.ORDER_GENERATED_UPDATED_SUCCESSFULLY);
      this.sideMenuService.getUnDoneOrdersCount();
      this.sideMenuService.getReminderedOrdersCount();
      if (this.isOrder()) this.initData();
    });
  }

  changeActionStatus(action: any) {
    action.status = !action.status;
  }

  rollbackElement(ele: any) {
    this.dialog
      .open(ConfirmCancelChangesDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.cancelChanges(ele).subscribe((result) => {
            this.msg.alert(Message.CANCEL_CHANGES);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
            if (this.isOrder()) {
              this.sideMenuService.getUnDoneOrdersCount();
              this.sideMenuService.getReminderedOrdersCount();
            }
          });
        } else {
          return;
        }
      });
  }

  onPrint(resource: any) {
    this.orderPrintService.setPrintResource(resource);
    this.router.navigate(["/order/print"]);
  }
}
